import React from 'react';

const LocalStorageDebug: React.FC = () => {
  const userData = localStorage.getItem('user');
  let parsedUser = null;
  let parseError = null;

  try {
    if (userData) {
      parsedUser = JSON.parse(userData);
    }
  } catch (e) {
    parseError = e;
  }

  return (
    <div className="p-4 bg-gray-100 rounded">
      <h3 className="font-bold mb-2">LocalStorage Debug</h3>
      
      <div className="mb-2">
        <strong>Raw user data:</strong>
        <pre className="bg-white p-2 rounded mt-1 text-xs overflow-auto">
          {userData || 'null'}
        </pre>
      </div>

      {parseError && (
        <div className="mb-2 text-red-600">
          <strong>Parse Error:</strong> {parseError.toString()}
        </div>
      )}

      {parsedUser && (
        <div className="mb-2">
          <strong>Parsed user object:</strong>
          <pre className="bg-white p-2 rounded mt-1 text-xs overflow-auto">
            {JSON.stringify(parsedUser, null, 2)}
          </pre>
          
          <div className="mt-2">
            <strong>Type checks:</strong>
            <ul className="text-sm">
              <li>user.role type: {typeof parsedUser.role}</li>
              <li>user.role value: {String(parsedUser.role)}</li>
              <li>user.role === &apos;admin&apos;: {String(parsedUser.role === 'admin')}</li>
              <li>user.roles exists: {String('roles' in parsedUser)}</li>
              {parsedUser.roles && (
                <li>user.roles value: {JSON.stringify(parsedUser.roles)}</li>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default LocalStorageDebug;